"use client";
import { Button } from "@/components/ui/button";
import { OptionsContext } from "@/provider/options-provider";
import { useContext } from "react";
import { PiSelectionPlusBold } from "react-icons/pi";
import { VscClearAll } from "react-icons/vsc";

export function SummarizeClearButton(props: {
  className?: React.ComponentProps<"button">["className"];
}) {
  const { groupSummaryItems, setGroupSummaryItems, searchResults } =
    useContext(OptionsContext);

  const clearSummarySelection = async () => {
    setGroupSummaryItems([]);
  };

  const selectAll = async () => {
    const allItems = searchResults
      ? searchResults?.map((x) => {
          return { id: x.id, type: x.shortCode };
        })
      : [];
    setGroupSummaryItems(allItems.flat());
  };

  const nothingSelected = groupSummaryItems.length === 0;
  return (
    <Button
      onClick={async () => {
        nothingSelected ? await selectAll() : await clearSummarySelection();
      }}
      className={props.className}
      type="button"
      tabIndex={-1}
      variant={"outline"}
      size={"icon"}
      title={nothingSelected ? "Select all" : "Clear selected items"}
    >
      {nothingSelected ? (
        <PiSelectionPlusBold className="h-4 w-4" />
      ) : (
        <VscClearAll className="h-4 w-4" />
      )}
    </Button>
  );
}
